module.exports = __webpack_public_path__ + "img/Prime_Rib_Spread.4e3e8e53.jpg";